


















import Vue from 'vue'
import { mdiCreditCardOutline } from '@mdi/js'
import { BaseCardTitle, BaseDataItem } from '@/components'
import { PaymentUpdater, BtnTryAgain } from './components'
import { IPayment } from '@/models'
import { PAYMENT_STATE, ROUTES } from '@/enums'

export default Vue.extend({
    name: 'PaymentStatus',

    components: { BaseCardTitle, BaseDataItem, PaymentUpdater, BtnTryAgain },

    model: {
        prop: 'payment',
        event: 'update:payment',
    },

    props: {
        orderCode: {
            type: String,
            required: true,
        },
        payment: {
            type: Object as () => IPayment,
            required: true,
        },
    },

    data: () => ({ mdiCreditCardOutline }),

    computed: {
        paymentInternal: {
            get(): IPayment {
                return this.payment
            },
            set(payment: IPayment) {
                this.$emit('update:payment', payment)
            },
        },

        paymentStateName(): string {
            switch (this.payment.state) {
                case PAYMENT_STATE.WAITING:
                    return 'W trakcie przetwarzania'
                case PAYMENT_STATE.REALISED:
                    return 'Zrealizowana'
                case PAYMENT_STATE.CANCELLED:
                    return 'Nieudana'
                default:
                    throw new Error(`Unknown payment state: ${this.payment.state}`)
            }
        },

        isPaymentInProgress(): boolean {
            return this.payment.state === PAYMENT_STATE.WAITING
        },

        isPaymentCancelled(): boolean {
            return !!this.payment && this.payment.state === PAYMENT_STATE.CANCELLED
        },
    },

    watch: {
        payment: {
            immediate: true,
            handler(payment: IPayment) {
                if (payment.state !== PAYMENT_STATE.REALISED) return

                this.$router.replace({
                    name: ROUTES.ORDER_DETAILS,
                    params: { orderCode: this.orderCode },
                })
            },
        },
    },
})
